import { isSafeInternalRedirectPath } from "../auth/authRedirectUrl";

function normalizePath(path) {
  if (typeof path !== "string" || path.length === 0) {
    return "";
  }

  if (path === "/") {
    return "/";
  }

  return path.replace(/\/+$/, "") || "/";
}


export function findStaticPageRedirectTarget(mappings, pathname) {
  if (!Array.isArray(mappings) || typeof pathname !== "string") {
    return null;
  }

  const normalizedPathname = normalizePath(pathname);

  for (const entry of mappings) {
    if (!entry || typeof entry !== "object") {
      continue;
    }

    const { source_url: sourceUrl, target_url: targetUrl } = entry;

    if (normalizePath(sourceUrl) !== normalizedPathname) {
      continue;
    }

    if (!isSafeInternalRedirectPath(targetUrl)) {
      continue;
    }

    if (normalizePath(targetUrl) === normalizedPathname) {
      continue;
    }

    return targetUrl;
  }

  return null;
}
